<template>
  <section class="container content-padding">
    <div class="row" v-if="serviceRequest">
      <div class="col-sm-8 offset-sm-2 col-12">
        <h2>{{ $t('message.service_request.service_request_detail') }}</h2>
        <div class="card panel-white">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                {{ $t('message.service_request.request') }} #{{ serviceRequest.id }} - {{ serviceRequest.service |
                multiLangName }}
              </div>
            </div>
          </div>
          <div class="card-body" v-if="!provider">
            <div class="row">
              <div class="col-4 text-left">
                <label>{{ $t('message.service_request.status') }}</label>
              </div>
              <div class="col-8 text-right -status-new">
                {{ serviceRequest.service_request_status | multiLangName }}
              </div>
            </div>
          </div>
          <div class="card-body" v-if="serviceRequest.service_date">
            <div class="row">
              <div class="col-4 text-left">
                <label>{{ $t('message.service_request.service_date') }}</label>
              </div>
              <div class="col-8 text-right">
                {{ serviceRequest.service_date | prettyDate }}
              </div>
            </div>
          </div>
          <div class="card-body" v-if="serviceRequest.duration_remark">
            <div class="row">
              <div class="col-4 text-left">
                <label>{{ $t('message.service_request.service_date_duration_remark') }}</label>
              </div>
              <div class="col-8 text-right">
                {{ serviceRequest.duration_remark }}
              </div>
            </div>
          </div>
          <div class="card-body" v-if="serviceRequest.service_request_purpose">
            <div class="row">
              <div class="col-4 text-left">
                <label>{{ $t('message.service_request.purpose') }}</label>
              </div>
              <div class="col-8 text-right">
                {{ serviceRequest.service_request_purpose | multiLangName }}
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-4 text-left">
                <label>{{ textData.labelType }}</label>
              </div>
              <div class="col-8 text-right">
                <div>{{ serviceRequest.building_type | multiLangName }}</div>
                <div class="mt-1">{{ serviceRequest.building_size }}</div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-4 text-left">
                <label>{{ $t('message.service_request.address') }}</label>
              </div>
              <div class="col-8 text-right">
                {{ serviceRequest.building_address }}
                <br>
                <span class="text-black-50">
                  <span v-if="serviceRequest.sub_district">
                    {{ serviceRequest.sub_district | multiLangName }}
                  </span>
                  {{ serviceRequest.district | multiLangName }}
                  {{ serviceRequest.address_province | multiLangName }}
                </span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-4 text-left">
                <label>{{ $t('message.service_request.remark') }}</label>
              </div>
              <div class="col-8 text-right">
                <div v-html="serviceRequest.remark" v-linkified></div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <label>{{ $t('message.service_request.photos') }}</label>
              </div>
            </div>
            <div class="row">
              <template v-for="picture, index in serviceRequest.service_request_photos">
                <div class="col-4 p-2"
                     :class="{'p-3' : !$mq.phone}">
                  <a href=""
                     @click.prevent="galleryIndex = index">
                    <div v-lazy:background-image="picture.image_xl" class="img-gallery"></div>
                  </a>
                </div>
              </template>
              <!-- Gallery -->
              <Tinybox v-model="galleryIndex" :images="_.map(serviceRequest.service_request_photos,'image_xl')" loop no-thumbs />
            </div>
          </div>
          <div class="card-body" v-if="!provider">
            <div class="row">
              <div class="col-4 text-left">
                <label>{{ $t('message.service_request.service_cost') }}</label>
              </div>
              <div class="col-8 text-right">
                <span v-if="serviceRequest.service_cost">{{ serviceRequest.service_cost | currency }}</span>
                <span v-else class="text-orange">{{ $t('message.service_request.evaluating_cost') }}</span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="text-remark mb-3">
                  {{ $t('message.service_request.service_cost_remark') }}
                </div>
                <a href="https://line.me/R/ti/p/%40hnk7011n"
                   target="_blank"
                   class="btn btn-block btn-outline-info">
                  {{ $t('message.button.contact_admin') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col text-center">
        <div class="mb-3">
          <i class="fal fa-times-circle -status-alert fa-3x"></i>
        </div>
        <h2>No Data</h2>
      </div>
    </div>

  </section>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    props: {
      provider: Boolean
    },
    data () {
      return {
        textData: {
          labelType: null
        },
        serviceRequestId: this.$route.params.id,
        galleryIndex: null
      }
    },
    computed: {
      ...mapState({
        serviceRequest: state => state.serviceRequest.serviceRequestDetail,
        user: state => state.auth.user,
        token: state => state.auth.token
      })
    },
    watch: {
      serviceRequest () {
        if (this.serviceRequest) {
          this.setTextLabel(this.serviceRequest.service_id)
        }
      }
    },
    methods: {
      ...mapActions('auth', ['getToken']),
      ...mapActions('serviceRequest', ['loadServiceRequestDetail']),
      setTextLabel (serviceId) {
        switch (serviceId) {
          case 13:
          case 24:
            this.textData.labelType = this.$i18n.t('message.service_request.building_type')
            break
          case 16:
            this.textData.labelType = this.$i18n.t('message.service_request.ac_type')
            break
        }
      }
    },
    async mounted () {
      if (!this.user) {
        const submitData = {
          service_request_id: this.serviceRequestId,
          validation: this.$route.query.validation
        }
        await this.getToken(submitData)
        if (this.token) {
          await this.loadServiceRequestDetail(this.serviceRequestId)
        }
      } else {
        await this.loadServiceRequestDetail(this.serviceRequestId)
      }
    },
    created () {
      this.$store.commit('serviceRequest/SET_SERVICE_REQUEST_DETAIL', null)
    }
  }
</script>

<style scoped>
  .img-gallery {
    width: auto;
    height: 160px;
    border-radius: 0.5rem;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  @media only screen and (max-width: 600px) {
    .img-gallery {
      height: 110px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/serviceRequest/ServiceRequestDetailForPartner.vue